<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table"
  >
    <template #rules="{ visible, params }">
      <Details :row="params" v-if="visible"/>
    </template>
  </cTable>
</template>

<script>
import {
  getBindFre,
  delBindFre,
  addBindFre,
  getOrderType,
  getTransportMode,
  getLog2,
  unOperation,
  getBindFreight,
  filterFreight,
  batchBind
} from "@/api/user/client";
import {getCountry} from "@/api/system/country";

import {getDiscount, getFilterResult} from "@/api/finance/freight";
import cTable from "@/base/common/index";
import Details from "./details";

export default {
  props: {
    rows: {
      type: Object
    }
  },
  components: {
    cTable,
    Details
  },
  data() {
    return {
      selectData: {},
      methods: {
        list: p => {
          p.clientId = this.rows.id;
          return getBindFre(p);
        },
        getCountry,
        delBindFre,
        addBindFre,
        getOrderType,
        getTransportMode,
        getBindFreight,
        beforeHandleList({data}) {
          return data.rows.map(item => {
            item.quotation.id = item.id;
            item.quotation.cod_type = item.cod_type;
            item.quotation.channel_mode = item.channel_mode;
            item.quotation.battery = item.battery;
            item.quotation.do_type = item.do_type;
            item.quotation.type = item.type;
            item.quotation.is_smsa = item.is_smsa;
            item.quotation.quotation_id = item.quotation_id;
            item.quotation.audit_status = item.audit_status;
            item.quotation.self_pick_up = item.self_pick_up;
            item.quotation.do_action =
              item.audit_log && item.audit_log.do_action;
            item.quotation.create_time =
              item.audit_log && item.audit_log.create_time;
            item.quotation.operator_name =
              item.audit_log && item.audit_log.operator_name;
            item = item.quotation;

            return item;
          });
        },
        getLog2,
        unOperation,
        batchBind,
        modalList: params => {
          let item = this.modals.batchBind.table.header.searchs.find(
            t => params[t.key]
          );
          if (!item) {
            this.$Message["warning"]({
              content: this.$t("search criteria cannot be empty"),
              background: true
            });
            return;
          }
          params.client_id = this.rows.id;
          return filterFreight(params);
        },
        beforeModalList({data}) {
          return data;
        }
      },
      config: {
        height: 640,
        rows: this.rows,
        resize: false,
        slot: "div"
      },
      modals: {
        batchBind: {
          methods: {
            ok({close}) {
              let ids = this.selectAll.map(t => t.id);
              if (!ids.length) {
                return this.$Message.error({
                  content: this.$t("choose price"),
                  background: true
                });
              }
              this.$page
                .handleRequestMethods(
                  "batchBind",
                  {
                    ids,
                    client_id: this.$page.config.rows.id,
                    ...this.getSearchForm()
                  },
                  true,
                  true
                )
                .then(res => {
                  close();
                });
            }
          },
          config: {
            title: this.$t("batchBind"),
            modalBind: {
              width: 80,
              draggable: true
            }
          },
          table: {
            header: {
              searchs: [
                {
                  key: "dd_type",
                  placeholder() {
                    return this.$t("DD Type");
                  },
                  component: "Select",
                  options: [
                    {
                      label: "DDP",
                      value: "DDP"
                    },
                    {
                      label: "DDU",
                      value: "DDU"
                    }
                  ]
                },
                {
                  key: "cod_type",
                  placeholder: () => this.$t("cod_type_txt"),
                  component: "Select",
                  options: []
                },
                {
                  key: "order_type",
                  placeholder: () => this.$t("order_type_t"),
                  component: "Select",
                  options: []
                },
                {
                  placeholder: () => this.$t("battery"),
                  key: "battery",
                  component: "Select",
                  options: []
                },
                {
                  placeholder: () => this.$t("discount"),
                  key: "discount_group",
                  component: "Select",
                  options: []
                },
                {
                  placeholder: () => this.$t("DeliveryMode"),
                  key: "self_pick_up",
                  component: "Select",
                  options: []
                },
                {
                  placeholder: () => this.$t("Assign SMSA"),
                  key: "is_smsa",
                  component: "Select",
                  options: []
                },
                {
                  key: "keywords",
                  placeholder() {
                    return this.$t("keyword");
                  },
                  component: "Input"
                }
              ]
            },
            config: {
              height: 580
            },
            fields: [
              {
                type: "checkbox",
                width: 60,
                fixed: "left"
              },
              {
                name: () => this.$t("freightName"),
                key: "title",
                align: "left",
                minWidth: 250
              },
              {
                name: () => this.$t("from_country"),
                key: "from_country",
                minWidth: 95
              },
              {
                name: () => this.$t("target_country"),
                key: "to_country",
                minWidth: 95
              },
              {
                name: () => this.$t("DD Type"),
                key: "dd_type",
                width: 80
              },
              {
                key: "cod_type",
                name: () => this.$t("cod_type_txt"),
                width: 80
              },
              {
                key: "order_type",
                name: () => this.$t("order_type_t"),
                width: 80
              },
              {
                name: () => this.$t("battery"),
                key: "battery",
                width: 80
              },
              {
                name: () => this.$t("discount"),
                key: "discount_group",
                width: 80
              },
              {
                name: () => this.$t("DeliveryMode"),
                key: "self_pick_up",
                width: 80
              },
              {
                name: () => this.$t("Assign SMSA"),
                key: "is_smsa",
                width: 80
              }
            ]
          }
        },
        add: {
          type: "add",
          methods: {
            ok({row, close}) {
              let data = row;
              data.client_id = this.$page.config.rows.id;
              delete data.discount_group;
              this.$page.handleRequestMethods("addBindFre", data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            title: this.$t("bind") + this.$t("bindFreight"),
            formBind: {
              labelWidth: 130
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              from_country: [
                {
                  required: true,
                  message: "fromCountry cannot be empty",
                  trigger: "change"
                }
              ],
              to_country: [
                {
                  required: true,
                  message: "targetCountry cannot be empty",
                  trigger: "change"
                }
              ],
              quotation_id: [
                {
                  required: true,
                  type: "number",
                  message: "freight cannot be empty",
                  trigger: "change"
                }
              ],
              do_type: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [
            {from_country: 24},
            {to_country: 24},
            {do_type: 24},
            {dd_type: 24},
            {discount_group: 24},
            {transport_code: 24},
            {type: 24},
            {agent_selector: 24},
            {transport_mode: 24},
            {quotation_id: 24},
            // { is_smsa: 24 },
            {cod_type: 24},
            {self_pick_up: 24},
            {battery: 24},
            {channel_mode: 24}
          ],
          fields: [
            {
              name: () => this.$t("from_country"),
              key: "from_country",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("from_country");
              },
              options: [],
              config: { label: "code", value: "code" },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCountry", {
                      allow_depart: 1
                    })
                  ).payload.rows;
                  this.$forceUpdate();
                },
                "on-change": ({ fields, row }) => {
                  this.filterChannel(fields, row)
                }
              }
            },
            {
              name: () => this.$t("target_country"),
              key: "to_country",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("target_country");
              },
              options: [],
              config: { label: "code", value: "code" },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getCountry", {
                      allow_arrive: 1
                    })
                  ).payload.rows;
                  this.$forceUpdate();
                },
                "on-change": ({ fields, row }) => {
                  this.filterChannel(fields, row)
                }
              }
            },
            {
              name: () => this.$t("type"),
              key: "do_type",
              component: "Radio",
              options: [
                { label: this.$t("positive"), value: 1 },
                { label: this.$t("reverse"), value: 2 }
              ],
              bind: {
                border: true
              },
              default: 1,
              methods: {
                "on-change": ({ fields, row }) => {
                  this.filterChannel(fields, row)
                }
              }
            },
            {
              name: () => this.$t("taxationType"),
              key: "dd_type",
              component: "Radio",
              placeholder() {
                return this.$t("select") + this.$t("taxationType");
              },
              bind: {
                border: true
              },
              options: [
                {
                  label: "DDP",
                  disabled: () => true,
                  value: "DDP"
                },
                {
                  label: "DDU",
                  disabled: () => true,
                  value: "DDU"
                }
              ],
              methods: {
                "on-change": ({ fields, row }) => {
                  this.filterChannel(fields, row)
                }
              }
            },
            {
              name: () => this.$t("discount"),
              placeholder: () => this.$t("discount"),
              key: "discount_group",
              component: "Select",
              options: [],
              methods: {
                "on-change": ({ fields, row }) => {
                  this.filterChannel(fields, row)
                }
              }
            },
            {
              name: this.$tz("运输方式"),
              key: "transport_code",
              component: "Select",
              placeholder: () => this.$tz("运输方式"),
              options: [],
              optionsFn: "method",
              optionsKey: "",
              default: "",
              methods: {
                "on-change": ({ fields, row }) => {
                  this.filterChannel(fields, row)
                }
              }
            },
            {
              name: () => this.$t("order_type_t"),
              key: "type",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("order_type_t");
              },
              options: [],
              config: { label: "name", value: "value" },
              default: -1,
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getOrderType")
                  ).payload;
                  this.$forceUpdate();
                },
                "on-change": ({ fields, row }) => {
                  this.filterChannel(fields, row)
                }
              }
            },
            {
              name: () => this.$t("agentName"),
              key: "agent_selector",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("agentName");
              },
              options: [
                {name: 'SMSA', value: 'is_smsa'},
                {name: 'JT', value: 'is_jt'},
                {name: 'iMile', value: 'is_smile'},
              ],
              config: { label: "name", value: "value" },
              default: 0,
              methods: {
                "on-change": ({ fields, row }) => {
                  this.filterChannel(fields, row)
                }
              }
            },

            {
              name: () => this.$t("cod_type"),
              key: "cod_type",
              component: "Select",
              options: [],
              placeholder() {
                return this.$t("select") + this.$t("cod_type");
              },
              methods: {
                async list({ field }) {
                  field.options = await this.$sel.getData("COD_TYPE");
                  this.$forceUpdate();
                },
                "on-change": ({ fields, row }) => {
                  this.filterChannel(fields, row)
                }
              }
            },
            {
              name: () => this.$t("PickUpType"),
              key: "self_pick_up",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("PickUpType");
              },
              options: [
                { label: this.$t("self_mention"), value: 1 },
                { label: this.$t("HomeDelivery"), value: 2 }
              ],
              bind: {
                border: true
              },
              methods: {
                "on-change": ({ fields, row }) => {
                  this.filterChannel(fields, row)
                }
              }
            },

            {
              name: () => this.$t("battery"),
              placeholder: () => this.$t("battery"),
              key: "battery",
              component: "Select",
              options: [],
              methods: {
                "on-change": ({ fields, row }) => {
                  this.filterChannel(fields, row)
                }
              }
            },


            {
              name: () => this.$t("freightName"),
              key: "quotation_id",
              component: "Select2",
              placeholder() {
                return this.$t("select") + this.$t("freightName");
              },
              options: [],
              config: { label: "name", value: "value" },
              disabled({ row }) {
                return !row.from_country || !row.to_country;
              },
            },

            {
              name: this.$tz("渠道,类型"),
              key: "channel_mode",
              placeholder() {
                return this.$tz("渠道,类型");
              },
              component: "Select",
              options: [],
              optionsFn: "",
              default: "0",
              optionsKey: "CHANNEL_MODE",
              methods: {
                "on-change": ({ fields, row }) => {
                  this.filterChannel(fields, row)
                }
              }
            },
          ]
        },
        showRules: {
          contentSlot: "rules",
          config: {
            modalBind: {
              width: 1300,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true
            },
            modalContentBind: {
              style: {
                height: "700px"
              }
            }
          },
          footer: {
            show: () => false
          }
        },
        log: {
          footer: {
            show() {
              return false;
            }
          },
          config: {
            listFn: "getLog2",
            modalBind: {
              width: 800,
              draggable: true,
              maskClosable: true
            }
          },
          table: {
            config: {
              height: 600
            },
            header: {
              show: () => true,
              config: {
                custom: false
              },
              searchs: [
                {
                  key: "keywords",
                  placeholder() {
                    return this.$t("keyword");
                  },
                  component: "Input"
                  // bind: {
                  //   type: "textarea",
                  //   autosize: { minRows: 2, maxRows: 2 }
                  // }
                }
              ]
            },
            footer: {
              show() {
                return true;
              }
            },
            fields: [
              {
                name: () => this.$t("operate"),
                key: "operate_name",
                width: 150
              },
              {
                name: () => this.$t("operation") + this.$t("content"),
                key: "operate_content",
                align: "left",
                type: "html",
                minWidth: 150
              },
              {
                name: () => this.$t("operation") + this.$t("time"),
                key: "operate_time",
                width: 170
              }
            ]
          }
        }
      },
      header: {
        searchs: [
          {
            key: "from_country",
            component: "Select",
            placeholder() {
              return this.$t("from_country");
            },
            options: [],
            config: {label: "code", value: "code"},
            methods: {
              async list({field}) {
                field.options = (
                  await this.$page.handleRequestMethods("getCountry", {
                    allow_depart: 1
                  })
                ).payload.rows;
                this.$forceUpdate();
              }
            },
            bind: {
              style: "width:100px"
            }
          },
          {
            key: "to_country",
            component: "Select",
            placeholder() {
              return this.$t("target_country");
            },
            options: [],
            config: {label: "code", value: "code"},
            methods: {
              async list({field}) {
                field.options = (
                  await this.$page.handleRequestMethods("getCountry", {
                    allow_arrive: 1
                  })
                ).payload.rows;
                this.$forceUpdate();
              }
            },
            bind: {
              style: "width:100px"
            }
          },
          {
            key: "do_type",
            component: "Select",
            options: [
              {label: this.$t("positive"), value: 1},
              {label: this.$t("reverse"), value: 2}
            ],
            placeholder() {
              return this.$t("type");
            },
            bind: {
              style: "width:80px"
            }
          },
          {
            key: "type",
            component: "Select",
            placeholder() {
              return this.$t("order_type_t");
            },
            options: [],
            config: {label: "name", value: "value"},
            methods: {
              async list({field}) {
                field.options = (
                  await this.$page.handleRequestMethods("getOrderType")
                ).payload;
                this.$forceUpdate();
              }
            },
            bind: {
              style: "width:100px"
            }
          },
          {
            key: "agent_selector",
            component: "Select",
            options: [
              {label: this.$t("SMSA"), value: 'is_smsa'},
              {label: this.$t("JT"), value: 'is_jt'},
              {label: this.$t("iMile"), value: 'is_smile'},
            ],
            placeholder() {
              return "Assign Agent";
            },
            bind: {
              style: "width:100px"
            }
          },
          {
            key: "cod_type",
            component: "Select",
            options: [],
            placeholder() {
              return this.$t("cod_type");
            },
            methods: {
              async list({field}) {
                field.options = await this.$sel.getData("COD_TYPE");
                this.$forceUpdate();
              }
            },
            bind: {
              style: "width:100px"
            }
          },
          {
            key: "self_pick_up",
            component: "Select",
            placeholder() {
              return this.$t("PickUpType");
            },
            options: [
              {label: this.$t("self_mention"), value: 1},
              {label: this.$t("HomeDelivery"), value: 2}
            ],
            bind: {
              style: "width:100px"
            }
          },
          {
            key: "channel_mode",
            placeholder() {
              return this.$tz("渠道,类型");
            },
            component: "Select",
            options: [],
            optionsFn: "",
            optionsKey: "CHANNEL_MODE"
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              // type: "textarea",
              //  autosize: { minRows: 2, maxRows: 2 }
              style: "width:100px"
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 97
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            },
            {
              name: () => this.$t("unbind"),
              type: "unbind",
              fnName: "unbind",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-trash",
                type: "default"
              },
              id: 599
            },
            {
              name: () => this.$t("cancel") + this.$t("auditOrder"),
              type: "unOperation",
              fnName: "unOperation",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                // icon: "md-trash",
                type: "error"
              },
              id: 650
            },
            {
              name: () => this.$t("updateLog"),
              type: "updateLog",
              fnName: "updateLog",
              bind: {
                type: "success"
              }
            },
            {
              name: () => this.$t("batchBind"),
              type: "batchBind",
              fnName: "batchBind",
              bind: {
                type: "success"
              }
            }
          ],
          methods: {
            batchBind() {
              this.getModal("batchBind").open();
            },
            updateLog() {
              let data = {
                id: this.config.rows.id,
                type: "feright"
              };
              this.getModal("log").open({}, function () {
                this.pageConfig.data = data;
                this.getList();
                this.setTitle(
                  this.$t("bindFreight") + "(" + this.$t("updateLog") + ")"
                );
              });
            },
            export() {
              this.exportExc(
                this.$t("b2bClient") +
                this.config.rows.account +
                "(" +
                this.$t("bindFreight") +
                ")"
              );
            },
            add() {
              this.getModal("add").open({dd_type: this.config.rows.dd_type});
            },
            unbind() {
              let data = {
                id: this.selectAll.map(item => item.id)
              };
              this.$Modal.confirm({
                title: this.$t("unbind"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("delBindFre", data).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            },
            unOperation() {
              let data = {
                ids: this.selectAll.map(item => item.id)
              };
              this.$Modal.confirm({
                title: this.$t("withdraw") + this.$t("operation"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("unOperation", data).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60
        },
        {
          name: () => this.$t("freightName"),
          key: "title",
          align: "left",
          minWidth: 250
        },
        {
          name: () => this.$t("from_country"),
          key: "from_country",
          minWidth: 95
        },
        {
          name: () => this.$t("target_country"),
          key: "to_country",
          minWidth: 95
        },
        {
          name: () => this.$t("duty_rate"),
          key: "duty_rate",
          minWidth: 95
        },
        {
          name: () => this.$t("paper_fee"),
          key: "paper_fee",
          minWidth: 110
        },
        {
          name: () => this.$t("convert_rate"),
          key: "convert_rate",
          minWidth: 95
        },
        {
          name: () => this.$t("express_currency"),
          key: "express_currency",
          minWidth: 95
        },
        {
          name: () => this.$t("tax_currency"),
          key: "tax_currency",
          minWidth: 95
        },
        {
          name: () => this.$t("order_type_t"),
          key: "type",
          minWidth: 95
        },
        {
          name: () => this.$t("positive") + "/" + this.$t("reverse"),
          key: "do_type",
          minWidth: 95
        },

        {
          name: () => this.$t("PickUpType"),
          key: "self_pick_up",
          minWidth: 95
        },
        {
          name: () => "代理类型",
          key: "agentName",
          minWidth: 95,
        },
        {
          name: () => this.$t("cod_type"),
          key: "cod_type",
          minWidth: 95
        },
        {
          name: () => this.$t("battery"),
          key: "battery",
          minWidth: 95
        },
        {
          name: () => this.$tz("渠道,类型"),
          key: "channel_mode",
          minWidth: 110
        },
        {
          name: this.$t("auditOrder"),
          children: [
            {
              name: () => this.$t("exlType"),
              key: "audit_status",
              minWidth: 95,
              render: (h, {row}) => {
                let list = [
                  {label: this.$t("normal"), value: 0},
                  {label: this.$t("wait") + this.$t("auditOrder"), value: 10},
                  {label: this.$t("through"), value: 20},
                  {label: this.$t("not_through"), value: 30}
                ];
                return h(
                  "span",
                  {
                    style: {
                      color:
                        row.audit_status == 10 || row.audit_status == 30
                          ? "red"
                          : ""
                    }
                  },
                  list.find(item => item.value == row.audit_status).label
                );
              }
            },
            {
              name: () => this.$t("operation"),
              key: "do_action",
              minWidth: 95,
              methods: {
                render({value}) {
                  let list = [
                    {label: this.$t("unbind"), value: "remove"},
                    {label: this.$t("bind"), value: "add"}
                  ];
                  return value && list.find(item => item.value == value).label;
                }
              }
            },
            {
              name: () => this.$t("time"),
              key: "create_time",
              width: 150
            },
            {
              name: () => this.$t("operate"),
              key: "operator_name",
              minWidth: 95
            }
          ]
        },
        {
          name: this.$t("operation"),
          type: "btns",
          width: 100,
          fixed: "right",
          list: [
            {
              name: () => this.$t("freight_fees") + this.$t("freightrule"),
              type: "showDetails",
              fnName: "showDetails",
              bind: {
                type: "warning"
              }
            }
          ],
          methods: {
            showDetails({row}) {
              this.getModal("showRules").open(row, function () {
                this.setTitle(
                  row.title +
                  "(" +
                  this.$t("freight_fees") +
                  this.$t("freightrule") +
                  ")"
                );
              });
            }
          }
        }
        // {
        //   name: () => this.$t("method_name"),
        //   key: "method_name",
        //   minWidth: 95
        // },
        // {
        //   name: () => this.$t("callBack"),
        //   key: "callBack",
        //   minWidth: 95
        // }
      ]
    };
  },
  methods: {
    filterChannel(fields, row) {
      // 向后端查询特定的渠道
      getFilterResult(row).then(r => {
        if (r.data.status) {
          let item = fields.filter(rx => rx.key === 'quotation_id')[0]
          item.options = r.data.payload
        } else {
          this.$Message.warning(r.data.msg)
        }
      }).catch(r => {
        this.$Message.error(r.data.msg)
      })
    }
  },
  async mounted() {
    let table = this.$refs["table"];
    let star = 7;
    let options = [];
    for (; star <= 10; star += 0.5) {
      options.push({
        label:
          star == 10
            ? this.$t("no discount")
            : (this.$i18n.locale !== "en-US" ? star : star * 10) +
            " " +
            this.$t("Fold"),
        value: star * 10
      });
    }
    this.selectData = {
      battery: await table.$sel.getData("BATTERY_TYPE"),
      is_smsa: [
        {label: table.$t("YES"), value: 1},
        {label: table.$t("NO"), value: 0}
      ],
      cod_type: await table.$sel.getData("COD_TYPE"),
      dd_type: [
        {label: "DDP", value: "DDP", disabled: formData => !!formData.id},
        {label: "DDU", value: "DDU", disabled: formData => !!formData.id}
      ],
      order_type: (await getOrderType()).data.payload.map(t => {
        return {label: t.name, value: t.value};
      }),
      discount_group: (await getDiscount()).data.payload.map(t => {
        return {label: t.name, value: t.id};
      }),
      self_pick_up: await table.$sel.getData("SEND_TYPE")
    };
    this.modals.batchBind.table.header.searchs.forEach(item => {
      if (item.key && this.selectData[item.key]) {
        item.options = this.selectData[item.key];
      }
    });
    this.modals.add.fields.forEach(item => {
      if (item.key && this.selectData[item.key]) {
        item.options = this.selectData[item.key];
      }
    });
    this.header.searchs.forEach(async item => {
      if (item.key && this.selectData[item.key]) {
        item.options = this.selectData[item.key];
      }
      if (item.key === "country_id")
        item.options = (await getCountry()).data.payload.rows;
    });
  }
};
</script>
